import { render, staticRenderFns } from "./AddBlockDialog.vue?vue&type=template&id=5cfefcf7&scoped=true"
import script from "./AddBlockDialog.vue?vue&type=script&lang=js"
export * from "./AddBlockDialog.vue?vue&type=script&lang=js"
import style0 from "./AddBlockDialog.vue?vue&type=style&index=0&id=5cfefcf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfefcf7",
  null
  
)

export default component.exports